/* eslint-disable */
import axios from '../index'

const getAll = () => {
  return axios.get('services/all')
}
const insert = (data) => {
  return axios.post('services/form', data)
}
const getCategories = () => {
  return axios.get('services/categories')
}

const getSubCategories = () => {
  return axios.get('services/subcategories')
}

const api = { getAll, getCategories, getSubCategories, insert }


export default api;